import { RichText, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import { ISiteInfo } from '../SiteInfoCard/SiteInfoCard';

interface IProps {
  siteNameFormat: RichTextField;
  siteInfo: ISiteInfo | undefined;
  style?: React.CSSProperties;
}

const SiteNameRichText: React.FC<IProps> = (props) => {
  const style = props.style || {};
  const RTFromSiteCore: RichTextField = props.siteNameFormat || { value: '' };

  const siteInfo: ISiteInfo | undefined = props?.siteInfo;
  let newValue = '';

  if (siteInfo && Object.keys(siteInfo).length > 0) {
    const originalValue: string = RTFromSiteCore.value || '';
    const mergeTagsInText: string[] = (originalValue.match(/\[(.*?)\]/g) || []).map((tag) =>
      tag.slice(1, -1)
    );

    const replaceMergeTags = (): string => {
      let replacedValue = originalValue;
      mergeTagsInText?.forEach((tag) => {
        const tagValue = siteInfo[tag as keyof ISiteInfo] || '';
        replacedValue = replacedValue?.replace(new RegExp(`\\[${tag}\\]`, 'g'), tagValue as string);
      });
      return replacedValue;
    };

    newValue = replaceMergeTags();
  } else {
    newValue = RTFromSiteCore.value as string;
  }

  return <RichText data-testid="siteNameDetails" style={style} field={{ value: newValue }} />;
};

export default SiteNameRichText;
